import type { FaireProductEntity } from "../../entity_types/product";

export const p_ydj7vdmbj3: FaireProductEntity = {
  token: "p_ydj7vdmbj3",
  type: "product",
  name: "Decaf - Placer de la Tarde, Colombia",
  brandToken: "b_3juit7iu0l",
  brandName: "Go Get Em Tiger",
  imageUrl: "https://cdn.faire.com/fastly/2831157e8168aff4a0980db28c6eb8606a3fd8c251d25ee5e2b63f00ad5610c8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/46aebe0869d1207a6968a7322e8faa6bce9551705de0e2bd4a124decf13f264c.jpeg",
    "https://cdn.faire.com/fastly/62c55aaaf46f3e13bda3eea95e1bbe11863869678b2ebed11691df45c3b465f2.jpeg",
    "https://cdn.faire.com/fastly/00f9cc234db9ae3be79a43e2432596ee85ec468362ffadfa4787b62815fad7d2.jpeg",
    "https://cdn.faire.com/fastly/772233829639a6f199f5ded7fea5d3405ff68576d62e9ce853261f800684177a.jpeg",
    "https://cdn.faire.com/fastly/2271fc7b686f4c3a903e92f05a0ae1d9a85775d4b912bfdf4eb92b40784ae3a5.jpeg"
  ],
  priceDollars: 12.62,
  description: "\nPlacer de la Tarde is the rare decaf coffee that actually tastes delicious. This classic-profile Colombia coffee nuanced as a filter coffee and sturdy as an espresso with milk. Look for a full body and notes of caramel and baking chocolate.\n",
  tags: [],
  msrpDollars: 25.24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:58:18.986Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
